let ytApiPromise;

const loadYouTubeAPI = () => {
    if (ytApiPromise) return ytApiPromise; // already loading or loaded

    ytApiPromise = new Promise((resolve) => {
        // If YT is already available
        if (window.YT && window.YT.Player) {
            resolve(window.YT);
            return;
        }

        // Inject the script only if not already in the DOM
        if (!document.getElementById('youtubeAPI')) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            tag.id = 'youtubeAPI';
            document.head.appendChild(tag);
        }

        // YouTube calls this globally when ready
        window.onYouTubeIframeAPIReady = () => {
            resolve(window.YT);
        };
    });

    return ytApiPromise;
};
export default loadYouTubeAPI;
